import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../components/mensajes';
import { Loader, Dimmer } from 'semantic-ui-react';
import axios from "axios";


const CatalogoSupervisor = props => {

    let op = require('../../public/modulos/datos');
    let token = sessionStorage.getItem('jwtToken');

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const btnSalir = useRef();
    const txtCodigo = useRef();
    const txtCedula = useRef();

    const [idusu, setIdusu] = useState(null);
    const [vinpurt, setVinput] = useState(true);
    const [mostrarClavesup, setMostrarClavesup] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);

    const blanquear = () => {
        setIdusu(null);
        setVinput(true);
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancelar();
    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        let sigue = true;
        if (props.ope === 3) {

            if (txtCedula.current.value === '') {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación",
                    texto: "¡ Introduzca el Número de Cédula del Supervisor !",
                    icono: "informacion",
                });
                sigue = false;
                txtCedula.current.focus();
            }

            if (sigue === true) {
                let cedu = txtCedula.current.value.trim();
                let clav = txtCodigo.current.value.trim();
                seleccionarAcceso(cedu, clav);
            }

        }

    }

    const seleccionarAcceso = (cedula, clave) => {

        let endpoint = `${op.conexion}/api/athos/usuario/supervisor?cedula=${cedula}&clave=${clave}`;

        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.idusuario > 0) {
                        props.onHideAceptaCatalogo("AUTORIZADO");
                        props.onHideCancelar();
                    } else {
                        setMensaje({
                            mostrar: true,
                            titulo: "Notificacion",
                            texto: "¡ Cédula y/o Clave Incorrecto !",
                            icono: "informacion",
                        });
                    }
                }
                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            })
            .finally(() => {
                setActivate(false);
            });
    };

    const onChange = (e) => {

        if (e.target.name === 'clave') {
            if (e.target.value !== '') {
                setVinput(false);
            }
        }

    }

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        blanquear();
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
    }

    const handleInputNumeroChange = (event) => {
        event.preventDefault();
        if (event.which === 13 || typeof event.which === "undefined") {
            if (event.target.value !== "") {
                if (event.target.name === "cedula") {
                    txtCodigo.current.focus();
                } else if (event.target.name === "clave") {
                    btnAcepta.current.focus();
                }
            }
        }
    };

    const mostrarPasswordsup = () => setMostrarClavesup(!mostrarClavesup);

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                if (props.ope === 3) {
                    txtCedula.current.focus();
                }
            }}
        >
            <Modal.Header className='azulGradiant2 header-modal'>
                <div className="fw-bold text-light"><h3>SUPERVISOR</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <MensajeSiNo mensaje={mensajesino}
                    onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
                <Dimmer active={activate} inverted>
                    <Loader inverted>Cargando...</Loader>
                </Dimmer>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <fieldset className='row col-sm-12 mx-auto mb-1 px-0'>

                        <div className='col'>
                            <div className="input-group input-group-sm mb-2">
                                <label className="input-group-text" id="inputGroup-sizing-sm">CEDULA: </label>
                                <input autoComplete='off' type='text' name="cedula" ref={txtCedula} onKeyUp={handleInputNumeroChange} onBlur={handleInputNumeroChange} className="form-control bg-transparent fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                            </div>
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="inputGroup-sizing-sm">CLAVE DE SUPERVISOR: </label>
                                <input autoComplete='off' type={mostrarClavesup ? "text" : "password"} onChange={onChange} name="clave" ref={txtCodigo} onKeyUp={handleInputNumeroChange} className="form-control bg-transparent fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                <button
                                    style={{ textAlign: "center", color: "white" }}
                                    onClick={mostrarPasswordsup}
                                    className="btn btn-sm btn-info"
                                >
                                    <i
                                        className="fa fa-eye-slash"
                                    ></i>{" "}
                                </button>
                            </div>
                        </div>

                    </fieldset>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} className="btn btn-sm btn-success rounded-pill" style={{ margin: "5px" }} onClick={onChangeValidar}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoSupervisor;


// WEBPACK FOOTER //
// ./src/catalogos/catalogoSupervisor.js